import { render, staticRenderFns } from "./friendCoeffs.vue?vue&type=template&id=4ba8da36&"
import script from "./friendCoeffs.vue?vue&type=script&lang=js&"
export * from "./friendCoeffs.vue?vue&type=script&lang=js&"
import style0 from "./friendCoeffs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports